import React, {memo} from "react";
import AmountTd from "../../../../Table/Common/AmountTd";
import { LockIcon } from "../../../../Access/common/LockIcon";

function Amount(props) {
    const { record, hideInventoryCosting } = props;

    const { base_amount: amount } = record;
    if (hideInventoryCosting)
        return (<LockIcon className="grey" />);

    if (amount === '' || amount === undefined || amount === null)
        return null;

    return (
        <AmountTd amount={amount} className="amount-td" />
    );
}

export default memo(Amount);
